import React, { FC } from "react"
import { container, FlexBox } from "@components/wrapper"
import { Course } from "@interfaces/course/course"
import clsx from "clsx"
import { slider_column } from "@constants/styles"
import { ClassCard } from "@components/card"
import { CourseHeading } from "@modules/course-detail/components/index"

interface RelatedClassProps {
  screenWidth: number
  data: Course[]
}

export const RelatedCourse: FC<RelatedClassProps> = ({ screenWidth, data }) => {
  if (!data.length) {
    return <section id="related-class" />
  }

  return (
    <section className={clsx(container, "mb-[80px]")} id="related-class">
      <CourseHeading customMargin={clsx("sm:mb-5 mb-2")}>Lihat Juga Kelas Lainnya</CourseHeading>

      {screenWidth > 576 ? (
        <FlexBox className="gap-8">
          {data.slice(0, 4).map((value, index) => (
            <ClassCard key={index} data={value} className="w-1/4" />
          ))}
        </FlexBox>
      ) : (
        <div className={clsx(slider_column, "pb-5")}>
          <div className="w-fit flex py-0 px-[15px]">
            {data.slice(0, 4).map((value, index) => (
              <ClassCard key={index} data={value} className="mr-[4vw] w-[65vw]" />
            ))}
          </div>
        </div>
      )}
    </section>
  )
}
